import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import axios from 'axios';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CS

import { AuthProvider } from './components/StoreValue';

axios.defaults.timeout = 30000;
// New way (React 18):
const container = document.getElementById('root');
const root = createRoot(container); // Create root with the container

root.render(
    <App />
);